const rawdata=[
    {
        "albumId": 1,
        "id": 1,
        "title": "accusamus beatae ad facilis cum similique qui sunt",
        "url": "https://via.placeholder.com/600/92c952",
        "thumbnailUrl": "https://via.placeholder.com/150/92c952"
      },
      {
        "albumId": 1,
        "id": 2,
        "title": "reprehenderit est deserunt velit ipsam",
        "url": "https://via.placeholder.com/600/771796",
        "thumbnailUrl": "https://via.placeholder.com/150/771796"
      },
      {
        "albumId": 1,
        "id": 3,
        "title": "officia porro iure quia iusto qui ipsa ut modi",
        "url": "https://via.placeholder.com/600/24f355",
        "thumbnailUrl": "https://via.placeholder.com/150/24f355"
      },
      {
        "albumId": 1,
        "id": 4,
        "title": "culpa odio esse rerum omnis laboriosam voluptate repudiandae",
        "url": "https://via.placeholder.com/600/d32776",
        "thumbnailUrl": "https://via.placeholder.com/150/d32776"
      },
      {
        "albumId": 1,
        "id": 5,
        "title": "natus nisi omnis corporis facere molestiae rerum in",
        "url": "https://via.placeholder.com/600/f66b97",
        "thumbnailUrl": "https://via.placeholder.com/150/f66b97"
      },
      {
        "albumId": 2,
        "id": 51,
        "title": "non sunt voluptatem placeat consequuntur rem incidunt",
        "url": "https://via.placeholder.com/600/8e973b",
        "thumbnailUrl": "https://via.placeholder.com/150/8e973b"
      },
      {
        "albumId": 2,
        "id": 52,
        "title": "eveniet pariatur quia nobis reiciendis laboriosam ea",
        "url": "https://via.placeholder.com/600/121fa4",
        "thumbnailUrl": "https://via.placeholder.com/150/121fa4"
      },
      {
        "albumId": 2,
        "id": 53,
        "title": "soluta et harum aliquid officiis ab omnis consequatur",
        "url": "https://via.placeholder.com/600/6efc5f",
        "thumbnailUrl": "https://via.placeholder.com/150/6efc5f"
      },
      {
        "albumId": 2,
        "id": 54,
        "title": "ut ex quibusdam dolore mollitia",
        "url": "https://via.placeholder.com/600/aa8f2e",
        "thumbnailUrl": "https://via.placeholder.com/150/aa8f2e"
      },
      {
        "albumId": 2,
        "id": 55,
        "title": "voluptatem consequatur totam qui aut iure est vel",
        "url": "https://via.placeholder.com/600/5e04a4",
        "thumbnailUrl": "https://via.placeholder.com/150/5e04a4"
      },
      {
        "albumId": 3,
        "id": 101,
        "title": "incidunt alias vel enim",
        "url": "https://via.placeholder.com/600/e743b",
        "thumbnailUrl": "https://via.placeholder.com/150/e743b"
      },
      {
        "albumId": 3,
        "id": 102,
        "title": "eaque iste corporis tempora vero distinctio consequuntur nisi nesciunt",
        "url": "https://via.placeholder.com/600/a393af",
        "thumbnailUrl": "https://via.placeholder.com/150/a393af"
      },
      {
        "albumId": 3,
        "id": 103,
        "title": "et eius nisi in ut reprehenderit labore eum",
        "url": "https://via.placeholder.com/600/35cedf",
        "thumbnailUrl": "https://via.placeholder.com/150/35cedf"
      },
      {
        "albumId": 3,
        "id": 104,
        "title": "et natus vero quia totam aut et minima",
        "url": "https://via.placeholder.com/600/313b40",
        "thumbnailUrl": "https://via.placeholder.com/150/313b40"
      },
      {
        "albumId": 3,
        "id": 105,
        "title": "veritatis numquam eius",
        "url": "https://via.placeholder.com/600/eaf2e1",
        "thumbnailUrl": "https://via.placeholder.com/150/eaf2e1"
      },
      {
        "albumId": 4,
        "id": 151,
        "title": "possimus dolor minima provident ipsam",
        "url": "https://via.placeholder.com/600/1d2ad4",
        "thumbnailUrl": "https://via.placeholder.com/150/1d2ad4"
      },
      {
        "albumId": 4,
        "id": 152,
        "title": "et accusantium enim pariatur eum nihil fugit",
        "url": "https://via.placeholder.com/600/a01c5b",
        "thumbnailUrl": "https://via.placeholder.com/150/a01c5b"
      },
      {
        "albumId": 4,
        "id": 153,
        "title": "eum laborum in sunt ea",
        "url": "https://via.placeholder.com/600/9da52c",
        "thumbnailUrl": "https://via.placeholder.com/150/9da52c"
      },
      {
        "albumId": 4,
        "id": 154,
        "title": "dolorum ipsam odit",
        "url": "https://via.placeholder.com/600/7f330f",
        "thumbnailUrl": "https://via.placeholder.com/150/7f330f"
      },
      {
        "albumId": 4,
        "id": 155,
        "title": "occaecati sed earum ab ut vel quibusdam perferendis nihil",
        "url": "https://via.placeholder.com/600/877cd8",
        "thumbnailUrl": "https://via.placeholder.com/150/877cd8"
      },
      {
        "albumId": 5,
        "id": 201,
        "title": "nesciunt dolorum consequatur ullam tempore accusamus debitis sit",
        "url": "https://via.placeholder.com/600/250289",
        "thumbnailUrl": "https://via.placeholder.com/150/250289"
      },
      {
        "albumId": 5,
        "id": 202,
        "title": "explicabo vel omnis corporis debitis qui qui",
        "url": "https://via.placeholder.com/600/6a0f83",
        "thumbnailUrl": "https://via.placeholder.com/150/6a0f83"
      },
      {
        "albumId": 5,
        "id": 203,
        "title": "labore vel voluptate ipsum quaerat debitis velit",
        "url": "https://via.placeholder.com/600/3a5c29",
        "thumbnailUrl": "https://via.placeholder.com/150/3a5c29"
      },
      {
        "albumId": 5,
        "id": 204,
        "title": "beatae est vel tenetur",
        "url": "https://via.placeholder.com/600/e4cc33",
        "thumbnailUrl": "https://via.placeholder.com/150/e4cc33"
      },
      {
        "albumId": 5,
        "id": 205,
        "title": "fugiat est ut ab sit et tempora",
        "url": "https://via.placeholder.com/600/dc17bf",
        "thumbnailUrl": "https://via.placeholder.com/150/dc17bf"
      },
]

export default rawdata;